import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { parseLocation } from 'automation-ui-routing/utils';
import AddButtonWithTooltips from 'automation-ui-canvas/components/canvas/AddButtonWithTooltips';
/**
 * The reason this decorator is used for these components
 * is that for performance reasons we want to only ever
 * re-render the UIDirectedGraph when there's a change
 * in the graph nodes. The `isSelected` prop that the two
 * Connector components use would trigger a full canvas
 * refresh. Instead, we grab the value directly from the
 * store and don't update any connector if it's not
 * explicitly selected.
 */
export const withIsSelected = WrappedComponent => compose(withRouter, connect((state, ownProps) => {
  const parsedQuery = parseLocation(ownProps.location);
  let selectedEdgeId = parsedQuery.edgeId;
  const activeFlowId = Number(parsedQuery.activeFlowId);
  if (ownProps.isMulti && activeFlowId !== ownProps.flowId) {
    selectedEdgeId = null;
  }
  const isSelected = selectedEdgeId === ownProps.edgeId;
  return {
    isSelected
  };
}))(WrappedComponent);
export const ConnectedAddButton = withIsSelected(AddButtonWithTooltips);